<button mat-raised-button
  [disabled]="isFullTextSearch"
  color="primary"
  (click)="onCreateFolder()">
  {{'COMMON.LABEL.ADD_FOLDER' | translate}}
</button>